<div class="container">
    <div class="section">
        <div data-qa-id="locums-rec-submittal-info-header" class="nova__label">Submittal Info:</div>
        <div class="content-wrapper" data-qa-id="locums-rec-submittal-info-value" [innerHtml]="job?.submitInfo | linkify:'_blank'"></div>
    </div>
    <div class="section">
        <div data-qa-id="locums-rec-special-Instr-header" class="nova__label">Special Instructions:</div>
        <div class="content-wrapper" data-qa-id="locums-rec-special-Instr-value" [innerHtml]="job?.additionalNotes | linkify:'_blank'"></div>
    </div>
    <nova-create-margin-calculator [job]="job"></nova-create-margin-calculator>
</div>
